import React, { Component } from 'react';
import classname from 'classnames';

import BZCarousel from 'web-common/bizzabo-components/components/BZCarousel';
import { AgendaContextConsumer } from '../../AgendaContextProvider';
import SpeakerElement from './SpeakerElement';

import {
    XS_WIDTH,
    M_WIDTH,
    L_WIDTH,
    XL_WIDTH,
    SBS_VIEW_MODE_1_SESSION,
    SBS_VIEW_MODE_2_SESSIONS,
    SBS_VIEW_MODE_3_SESSIONS,
    ARRAY_NUMERATION_OFFSET
} from 'constants/Enums';
import { getScreenWidth } from '../../../../Utils';

const Arrow = ({ className, style, onClick, mirror = false, isHidden = false }) => {
    const iconClass = classname('fa icon-AgendaAtt_arrow bz-bold', { mirror: mirror });
    const rootClass = classname('custom-color color-1', className);
    return <div
        className={rootClass}
        style={{ ...style, display: isHidden? 'none': 'block' }}
        onClick={onClick}>
        <i className={iconClass} />
    </div>;
};

const stopPropagation = (e) => e.stopPropagation();

const sliderDefault = {
    arrows: true,
    responsive: [
        { breakpoint: XS_WIDTH, settings: { slidesToShow: 1.2, arrows: false }},
        { breakpoint: M_WIDTH, settings: { slidesToShow: 2, arrows: false, slidesToScroll: 1 }},
        { breakpoint: L_WIDTH, settings: { slidesToShow: 3, slidesToScroll: 3 }},
        { breakpoint: XL_WIDTH, settings: { slidesToShow: 4, slidesToScroll: 4}},
    ]
};

const speakersCountByViewMode = {
    [SBS_VIEW_MODE_3_SESSIONS]: [
        { breakpoint: XS_WIDTH, settings: { slidesToShow: 1.2, arrows: true, slidesToScroll: 1 }},
        { breakpoint: M_WIDTH, settings: { slidesToShow: 1.2, arrows: false, slidesToScroll: 1 }},
        { breakpoint: L_WIDTH, settings: { slidesToShow: 1.3, slidesToScroll: 1}},
        { breakpoint: XL_WIDTH, settings: { slidesToShow: 1.3, slidesToScroll: 1 }},
    ],
    [SBS_VIEW_MODE_2_SESSIONS]: [
        { breakpoint: XS_WIDTH, settings: { slidesToShow: 2, slidesToScroll: 2 }},
        { breakpoint: M_WIDTH, settings: { slidesToShow: 2, slidesToScroll: 2 }},
        { breakpoint: L_WIDTH, settings: { slidesToShow: 2.3, slidesToScroll: 2 }},
        { breakpoint: XL_WIDTH, settings: { slidesToShow: 2.3, slidesToScroll: 2 }},
    ],
    [SBS_VIEW_MODE_1_SESSION]: [
        { breakpoint: XS_WIDTH, settings: { slidesToShow: 1.2, arrows: false }},
        { breakpoint: M_WIDTH, settings: { slidesToShow: 1.2, arrows: false, slidesToScroll: 1 }},
        { breakpoint: L_WIDTH, settings: { slidesToShow: 3, slidesToScroll: 3 }},
        { breakpoint: XL_WIDTH, settings: { slidesToShow: 4, slidesToScroll: 4}}
    ]
};


class SessionSpeakersSessionsList extends Component {
    state = {
        hidePrevArrow: true,
        hideNextArrow: false,
    };

    slideChangeHandler = (newIndex) => {
        const { SBSViewMode, selectedSpeakers } = this.props;
        const sliderSettings = SBSViewMode ? speakersCountByViewMode[SBSViewMode]: sliderDefault.responsive;
        const screenWidth = getScreenWidth();
        const currentDevice = sliderSettings.find(device => screenWidth <= device.breakpoint);
        const itemsPerSlide = Math.floor(currentDevice.settings.slidesToShow);
        this.setState({
            hidePrevArrow: newIndex === 0,
            hideNextArrow: newIndex > (selectedSpeakers.length - ARRAY_NUMERATION_OFFSET - itemsPerSlide),
            isClientSideRendered: typeof document !== 'undefined' && typeof window !== 'undefined'
        });
    };

    render() {
        const {
            speakers,
            classInfo,
            sizeImage,
            className = '',
            classLink = '',
            classCarousel = '',
            showEmptyLine,
            selectedSpeakers = [],
            isWidget,
            SBSViewMode
        } = this.props;
        const { hidePrevArrow, hideNextArrow } = this.state;
        const carouselClass = classname('speakers-carousel full-width', classCarousel);
        const carouselSettings = {
            ...sliderDefault,
            ...SBSViewMode && {responsive: speakersCountByViewMode[SBSViewMode]},
            afterChange: this.slideChangeHandler,
            prevArrow: <Arrow mirror isHidden={hidePrevArrow} />,
            nextArrow: <Arrow isHidden={hideNextArrow}/>,
        };
        return !!selectedSpeakers.length &&
            <div className={className} onTouchMove={stopPropagation}>
                { selectedSpeakers.length === 1
                    ? <div className={carouselClass}>
                        {selectedSpeakers.map(({speakerId, role}) => {
                            const speaker = speakers[speakerId];
                            return !!speaker &&
                                <div key={1} className='padding-left-none session-one-speaker'>
                                    <AgendaContextConsumer>
                                        {(context) =>
                                            <SpeakerElement
                                                speaker={{...speaker, role}}
                                                classLink={classLink}
                                                sizeImage={sizeImage}
                                                classInfo={classInfo}
                                                showEmptyLine={showEmptyLine}
                                                isWidget={isWidget}
                                                context={context}
                                            />
                                        }
                                    </AgendaContextConsumer>
                                </div>;
                        })}
                    </div>
                    : <BZCarousel className={carouselClass} settings={carouselSettings}>
                        {(selectedSpeakers || []).map(({speakerId, role}, index) => {
                            const speaker = speakers[speakerId];
                            return !!speaker &&
                                <div key={index} className='padding-left-none'>
                                    <AgendaContextConsumer>
                                        {(context) =>
                                            <SpeakerElement
                                                speaker={{...speaker, role}}
                                                classLink={classLink}
                                                sizeImage={sizeImage}
                                                classInfo={classInfo}
                                                showEmptyLine={showEmptyLine}
                                                isWidget={isWidget}
                                                context={context}
                                            />
                                        }
                                    </AgendaContextConsumer>
                                </div>;
                        })}
                    </BZCarousel>
                }
            </div>;
    }
}

export default SessionSpeakersSessionsList;
